var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSleepioAccountIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#DDEFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17267_16943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5714 21.4289C22.9383 21.4289 24.8571 19.5101 24.8571 17.1431C24.8571 14.7762 22.9383 12.8574 20.5714 12.8574C18.2044 12.8574 16.2856 14.7762 16.2856 17.1431C16.2856 19.5101 18.2044 21.4289 20.5714 21.4289Z",
    stroke: "#082143",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5712 33.4286H12.8569V32.4993C12.8706 31.1927 13.2152 29.9107 13.8585 28.7734C14.5019 27.6361 15.423 26.6803 16.5359 25.9955C17.6488 25.3106 18.9171 24.9191 20.2223 24.8573C20.3387 24.8518 20.455 24.8489 20.5712 24.8486C20.6874 24.8489 20.8038 24.8518 20.9201 24.8573C22.2254 24.9191 23.4937 25.3106 24.6065 25.9955C25.2465 26.3893 25.823 26.8727 26.3198 27.4287",
    stroke: "#082143",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1426 26.5713L28.2855 35.1427L24.8569 32.5713",
    stroke: "#082143",
    strokeWidth: 1.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17267_16943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepioAccountIcon);
export default __webpack_public_path__ + "static/media/SleepioAccountIcon.93b129825a3efc095536c6b3df7df012.svg";
export { ForwardRef as ReactComponent };